import { render } from "./StatusBadge.vue?vue&type=template&id=3aed21e2"
import script from "./StatusBadge.vue?vue&type=script&lang=js"
export * from "./StatusBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__